import { Component, OnInit } from '@angular/core';
import { AccidentRecordService } from '../../../core/services/accident-record.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SETTINGS } from '../../../core/config/common.settings';
import { FleetService } from '../../../core/services/fleet.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ReportsService } from '../../../core/services/reports.service';

@Component({
  selector: 'app-single-view-accident',
  templateUrl: './single-view-accident.component.html',
  styleUrls: ['./single-view-accident.component.scss'],
})
export class SingleViewAccidentComponent implements OnInit {
  breadcrumbs: any[] = [];
  record: any;
  bookingOptions: any[] = [];
  selectedBooking: any;
  recordId: any;
  damageTypesOptions = SETTINGS.DAMAGE_TYPES;
  loading = false;
  generating = false;
  downloading = false;
  isPdfGenerated = false;
  pdf: any;

  editableDescription = '';
  isVisibleEditDescription = false;

  constructor(
    private accidentService: AccidentRecordService,
    private messages: NzMessageService,
    private fleetService: FleetService,
    private reportService: ReportsService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.recordId = this.route.snapshot.paramMap.get('id');
    this.getAccidentRecordById(this.recordId);
  }

  getAccidentRecordById(id: string): void {
    this.loading = true;
    this.accidentService.getAccidentRecordWithDetailsById(id).subscribe(
      (res) => {
        this.record = res as any;
        this.editableDescription = this.record?.description;
        this.setBreadcrumbs(res);
        if (res?.bookingDetails?.booking) {
          this.fleetService
            .getAllBookingsByFleet(res?.fleet?._id)
            .subscribe((resp: any) => {
              this.selectedBooking = resp?.find(
                (bo: any) => bo._id === res?.bookingDetails?.booking,
              );
            });
        }
        this.loading = false;
      },
      (e: any) => {
        this.messages.create('error', 'Error');
      },
    );
  }

  getDamageNumber(type: string): string {
    let textNo = '';
    this.damageTypesOptions.forEach((t: any) => {
      if (type === t.value) {
        textNo = t.no.toString();
      }
    });
    return textNo;
  }

  setBreadcrumbs(data: any): void {
    this.breadcrumbs = [
      {
        title: ` Fleets `,
        route: `/admin/fleets`,
        icon: 'car',
      },
      {
        title: ` ${data?.fleet?.vehicleDetails?.registrationNumber} `,
        route: `/admin/fleets/${data?.fleet?._id}`,
      },
      {
        title: ` Accident Records `,
        route: [
          `/admin/fleets/${data?.fleet?._id}`,
          { pageName: 'fleetAccident' },
        ],
      },
      {
        title: ` ${data?.refNo} `,
      },
    ];
  }

  getDamageId(index: any): string {
    const id: string = (index + 1).toString();
    return id.padStart(3, '0');
  }

  goTo(type: string) {
    switch (type) {
      case 'booking':
        switch (this.selectedBooking.type) {
          case 'Rent':
            this.router.navigate([
              `admin/booking-rent/${this.selectedBooking._id}`,
            ]);
            break;
          case 'Transfer':
            this.router.navigate([
              `admin/booking-transfer/${this.selectedBooking._id}`,
            ]);
            break;
          case 'Other':
            this.router.navigate([
              `admin/booking-other/${this.selectedBooking._id}`,
            ]);
            break;
        }
        break;
      case 'customer':
        this.router.navigate([
          `admin/customers/${this.selectedBooking.customerId}`,
        ]);
        break;
    }
  }

  setEditDescription(): void {
    this.isVisibleEditDescription = true;
  }

  handleCancelEditDescription(): void {
    this.isVisibleEditDescription = false;
    this.editableDescription = this.record?.description;
  }

  handleOkEditDescription(): void {
    this.accidentService
      .updateAccidentRecord({
        _id: this.recordId,
        description: this.editableDescription,
      })
      .subscribe(
        (res: any) => {
          this.messages.create(
            'success',
            'Accident description is updated successfully!',
          );
          this.getAccidentRecordById(this.recordId);
          this.isPdfGenerated = false;
          this.pdf = null;
        },
        (e: any) => {
          this.isPdfGenerated = false;
          this.pdf = null;
          this.messages.create('error', 'Error');
        },
      );
  }

  handleCancel(): void {}

  generateReport(): void {
    this.generating = true;
    this.reportService.generateDamageReport(this.recordId).then((res: any) => {
      this.pdf = res;
      this.isPdfGenerated = true;
      this.generating = false;
    });
  }

  downloadReport(): void {
    // this.downloading = true;
    this.reportService.downloadReport(this.pdf).then(() => {
      // this.downloading = false;
    });
  }

  previewReport(): void {
    this.reportService.viewReport(this.pdf).then(() => {});
  }

  printReport(): void {
    this.reportService.printReport(this.pdf).then(() => {});
  }

  emailPdf(): void {
    this.reportService.emailPdf();
    // const email = 'recipient@gmail.com';
    // const subject = 'Your email subject';
    // const body = 'Your email body content';
    //
    // // Create the mailto link
    // // Open the default email client (Gmail, if available)
    // window.location.href = `mailto:${email}?subject=${encodeURIComponent(
    //   subject,
    // )}&body=${encodeURIComponent(body)}`;
  }
}
